import cx from "classnames";
import React, { useEffect } from "react";
import { useNationalDogSurveyContext } from "../../NationalDogSurvey/NationalDogSurvey.context";
import { THANK_YOU_STATUS } from "../../NationalDogSurvey/fixtures";
import {
	SectionCurvedBorderBottom,
	SectionFurryCurvedBorderBottom,
} from "../../context/PageManager/PageManager.Borders";
import { Colours } from "../../utils/colours";
import {
	NDSDonateNow,
	NDSIntroLottie,
	NDSPostcodeLotteryFindOutMore,
	NDSRelatedReading,
	NDSSocialMedia,
	NDSThankYouHeader,
	NDSWhatHappensNext,
} from "./NDSThankYou.components";
// import Layout from "../Layout"; // TODO this will need to be moved to the gatsby app
import * as styles from "./NDSThankYou.module.scss";

// TODO: Go through with Gareth, tidy up the remaining commented code and implement the related articles functionality

export interface NDSThankYouProps {
	screenId?: string;
	title: string;
	subTitle: string;
	body?: string;
	image: DogsTrust.MediaImageProps & { lottieFile?: boolean };
	relatedReadingTitle: string;
	relatedReadingBodyHtmlText: string;
	relatedReadingMap: NDS.RelatedReadingMap;
	helpDogs: {
		body: string;
		linkText: string;
		linkUrl: string;
		title: string;
	};

	share: {
		shareSectionTitle: string;
		shareSectionBody: string;
		shareText: string;
		xShareUrl: string;
		fbShareUrl: string;
		emailShareUrl: string;
		whatsappShareUrl: string;
	};
	handleChange?: (name: string, value: string | string[]) => void;
	confirmedValue?: string | string[];
	options?: DogsTrust.FormOption[];
	warmData?: NDS.WarmUserData;
	hidden?: boolean;
	formData: NDS.FormData;

	onSpecialNavigation?: (
		nextRoute: NDS.ScreenIndex,
		nextScreen: NDS.ScreenName,
		nextDogIndex?: number,
	) => void;
	currentDog: Record<string, string>;
	pageText?: string;
}
export const NDSThankYou: React.FC<NDSThankYouProps> = ({
	title,
	subTitle,
	body,
	image,
	hidden,
	relatedReadingTitle,
	relatedReadingBodyHtmlText,
	relatedReadingMap,
	share,
}) => {
	const { formData, handleThankYouReload } = useNationalDogSurveyContext();

	const [relatedContentItems, setRelatedContentItems] = React.useState<
		DogsTrust.SignPostCardProps[]
	>([]);

	useEffect(() => {
		const updatedRelatedContentItems: DogsTrust.SignPostCardProps[] = [];

		for (const fieldName of Object.keys(relatedReadingMap)) {
			const answered = formData[fieldName as NDS.FormFieldName];

			if (Array.isArray(answered)) {
				// If the answered value is an array, we need to check each value
				for (const answer of answered) {
					if (relatedReadingMap[fieldName][answer]) {
						updatedRelatedContentItems.push(
							relatedReadingMap[fieldName][answer],
						);
					}
				}

				continue;
			}

			if (answered === undefined || !relatedReadingMap[fieldName][answered]) {
				continue;
			}
			updatedRelatedContentItems.push(relatedReadingMap[fieldName][answered]);
		}

		// Make sure updatedRelatedContentItems is unique
		const uniqueItems = updatedRelatedContentItems.filter(
			(item, index, self) =>
				index === self.findIndex((t) => t.drupal_id === item.drupal_id),
		);
		setRelatedContentItems(uniqueItems);
	}, [formData, relatedReadingMap]);

	// biome-ignore lint/correctness/useExhaustiveDependencies: Run once
	useEffect(() => {
		const thankYouStatus = localStorage.getItem(THANK_YOU_STATUS);

		if (!thankYouStatus) {
			localStorage.setItem(THANK_YOU_STATUS, "viewed");
			return;
		}
		if (thankYouStatus === "viewed") {
			localStorage.removeItem(THANK_YOU_STATUS);
			handleThankYouReload();
			return;
		}
	}, []);

	return (
		<div
			className={cx(
				styles.ndsThankYouContainer,
				hidden && styles.visuallyHidden,
			)}
		>
			<NDSThankYouHeader title={title} subTitle={subTitle} />
			<NDSIntroLottie image={image} />
			<NDSWhatHappensNext body={body} />
			<NDSDonateNow />
			<SectionCurvedBorderBottom
				borderColour={Colours.SANDY_FUR}
				nextSection={{
					primaryColour: Colours.MIDNIGHT,
					sectionId: "NDSPostcodeLotterySignup",
					sectionType: "signup",
				}}
			/>

			<NDSPostcodeLotteryFindOutMore />
			<SectionFurryCurvedBorderBottom
				borderColour={Colours.MIDNIGHT}
				nextSection={{
					primaryColour: Colours.SUNSHINE_YELLOW,
					sectionId: "ArticlePageSocialMedia",
					sectionType: "social-media",
				}}
			/>

			<NDSSocialMedia share={share} />

			{relatedContentItems.length > 0 && (
				<NDSRelatedReading
					title={relatedReadingTitle}
					bodyHtmlText={relatedReadingBodyHtmlText}
					relatedContentItems={relatedContentItems}
				/>
			)}
		</div>
	);
};

export default NDSThankYou;
